function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    width: "80px",
    height: "80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface282512244"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,60.000002%,78.039217%)",
      fillOpacity: 1
    },
    d: "M 40 77.5 C 19.320312 77.5 2.5 60.679688 2.5 40 C 2.5 19.320312 19.320312 2.5 40 2.5 C 60.679688 2.5 77.5 19.320312 77.5 40 C 77.5 60.679688 60.679688 77.5 40 77.5 Z M 40 77.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,60.000002%,78.039217%)",
      fillOpacity: 1
    },
    d: "M 40 3 C 60.402344 3 77 19.597656 77 40 C 77 60.402344 60.402344 77 40 77 C 19.597656 77 3 60.402344 3 40 C 3 19.597656 19.597656 3 40 3 M 40 2 C 19.011719 2 2 19.011719 2 40 C 2 60.988281 19.011719 78 40 78 C 60.988281 78 78 60.988281 78 40 C 78 19.011719 60.988281 2 40 2 Z M 40 2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40 21 C 38.34375 21 37 22.34375 37 24 C 37 25.65625 38.34375 27 40 27 C 41.65625 27 43 25.65625 43 24 C 43 22.34375 41.65625 21 40 21 Z M 40 21 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43 56 L 43 31 L 35 31 L 35 33 L 37 33 L 37 56 L 35 56 L 35 58 L 45 58 L 45 56 Z M 43 56 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTooltip);
export default __webpack_public_path__ + "static/media/iconTooltip.178c9d66d5c92b7ae393123fd67b4b02.svg";
export { ForwardRef as ReactComponent };